import React from 'react'

import IconSvgContainer, { Props as IconSvgContainerProps } from './IconSvgContainer'

export type Props = IconSvgContainerProps

const IconError: React.FC = (props: Props) => (
    <IconSvgContainer width="60" height="60" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.3953 18.0527L38.4608 21.9872L37.7653 21.2917L41.6998 17.3572L42.3953 18.0527ZM37.2313 23.2166L18.051 42.397L17.3555 41.7014L36.5358 22.5211L37.2313 23.2166Z"
            fill="#EB5757"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.949 42.397L17.6048 18.0527L18.3003 17.3572L42.6445 41.7015L41.949 42.397Z"
            fill="#EB5757"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 0.983607C13.9747 0.983607 0.983607 13.9747 0.983607 30C0.983607 46.0253 13.9747 59.0164 30 59.0164C46.0253 59.0164 59.0164 46.0253 59.0164 30C59.0164 13.9747 46.0253 0.983607 30 0.983607ZM0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z"
            fill="#EB5757"
        />
    </IconSvgContainer>
)

export default IconError
